import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'; // CSS global do Swiper (v5.x)

Vue.use(VueAwesomeSwiper);
